module.exports = __webpack_public_path__ + "static/media/pn-pc-blue.81667395.svg";